import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, onBeforeUnmount, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import ManualInfoDataService from "@/services/ManualInfoDataService";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("Manual Maintenance");
const modalSubject = reactive([]);
const manualModalBody = reactive([]);
const manualInfo = reactive([]);
const oldColoredCategory = ref("");
const categoryColor = ref("0");
const getData = ref(false);
const categoryInfo = reactive([]);

const manualName = ref("");
const description = ref("");
const oldManualId = ref("");
const fileName = ref("");
const oldFileName = ref("");
const categoryInfoName = ref("");
const uploadFile = reactive([]);
const fileChange = ref("0");
const errDescription = ref("");
const errManualName = ref("");
const errContent = ref("");
const errCategoryName = ref("");
const oldManualName = ref("");

/** 初期表示設定 */
onMounted(function () {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  getManualList();
  getCategoryList();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var mydivh = document.getElementById("mydiv")?.clientHeight;
      tableHeight = (mydivh * 96) / 100 - 200;
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

const manualRowColoring = (category: any, index: any) => {
  categoryColor.value = index == 0 ? "0" : categoryColor.value;
  oldColoredCategory.value = index == 0 ? "" : oldColoredCategory.value;
  categoryColor.value = category != oldColoredCategory.value && oldColoredCategory.value != "" ? (categoryColor.value == "0" ? "1" : "0") : categoryColor.value;
  oldColoredCategory.value = category;
  if (categoryColor.value == "0") {
    return "#ffff";
  } else {
    return "#ffffe8";
  }
}

/** Get Manual List */
const getManualList = () => {
  isLoading.value = true;
  manualInfo.splice(0);
  const data = {};

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // get Manual Data
  ManualInfoDataService.getManualEdit(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        manualInfo.push(response.data);
      }
      getData.value = true;
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err040");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** Get Category List */
const getCategoryList = () => {
  isLoading.value = true;
  categoryInfo.splice(0);
  const data = {};

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // get Category Data
  ManualInfoDataService.getCategory(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        for (let info of response.data) {
          categoryInfo.push(info);
        }
      }
      getData.value = true;
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err041");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** update Manual List */
const updateManualList = () => {
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  var err = false;

  if (!inputCheck()) {
    return;
  }

  if (manualName.value != oldManualName.value) {
    for (var info = 0; info < manualInfo.length; info++) {
      if (manualInfo[info].name == manualName.value) {
        errManualName.value = i18n.t("alt060");
        err = true;
      }
    }
  }

  if (!err) {
    document.getElementById("modalCancel").click();
    var formData = new FormData();
    formData.append("name", manualName.value);
    formData.append("filename", fileName.value);
    formData.append("description", description.value);
    formData.append("categoryName", categoryInfoName.value);
    formData.append("oldFileName", oldFileName.value);
    formData.append("fileChange", fileChange.value);
    formData.append("oldManualId", oldManualId.value);

    if (fileChange.value == "1") {
      formData.append("myfile", uploadFile[0]);
    }

    // update Manual Data
    ManualInfoDataService.updateManualInfo(formData)
      .then((_) => {
        getManualList();
        alertMessage.value = i18n.t("suc014");
        alertState.value = "success";
        isLoading.value = false;
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = i18n.t("err035");
        if (e.response.data.message != undefined) {
          alertMessage.value = e.response.data.message;
        }
        alertState.value = "error";
        isLoading.value = false;
      });
  }
};

/** add Manual List */
const addManualList = () => {
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  if (!inputCheck()) {
    return;
  }
  var err = false;

  for (var info = 0; info < manualInfo.length; info++) {
    if (manualInfo[info].name == manualName.value) {
      errManualName.value = i18n.t("alt060");
      err = true;
    }
  }

  if (!err) {
    document.getElementById("modalCancel").click();
    var formData = new FormData();
    formData.append("name", manualName.value);
    formData.append("description", description.value);
    formData.append("categoryName", categoryInfoName.value);
    formData.append("myfile", uploadFile[0]);

    // add Manual Data
    ManualInfoDataService.addManualInfo(formData)
      .then((_) => {
        getManualList();
        alertMessage.value = i18n.t("suc008");
        alertState.value = "success";
        isLoading.value = false;
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = e.response.data.message;
        alertState.value = "error";
        isLoading.value = false;
      });
  }
};

// ファイル選択時の処理関数
const selectFile = (event) => {
  isLoading.value = false;
  fileChange.value = "1";
  uploadFile.splice(0);
  var file = event.target.files[0];
  fileName.value = file.name;
  uploadFile.push(file);
};

/** delete Manual List */
const deleteManualList = (param: any, index: any) => {
  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  const data = { manualId: param };

  if (confirm(i18n.t("cnf004"))) {
    // delete Manual Data
    ManualInfoDataService.deleteManualInfo(data)
      .then((_) => {
        alertMessage.value = i18n.t("suc020");
        alertState.value = "success";
        manualInfo[0].splice(index, 1);
        isLoading.value = false;
      })
      .catch((e: Error) => {
        console.log(e);
        alertMessage.value = i18n.t("err034");
        alertState.value = "error";
        isLoading.value = false;
      });
  } else {
    manualName;
    isLoading.value = false;
  }
};

const inputCheck = () => {
  var err = false;
  clearMsg();

  if (manualName.value == "") {
    errManualName.value = i18n.t("alt052");
    err = false;
  }
  if (description.value == "") {
    errDescription.value = i18n.t("alt053");
    err = true;
  }
  if (fileName.value == "") {
    errContent.value = i18n.t("alt056");
    err = true;
  }
  if (fileDuplicateCheck()) {
    errContent.value = i18n.t("alt051");
    err = true;
  }
  if (categoryInfoName.value == "") {
    errCategoryName.value = i18n.t("alt054");
    err = true;
  }

  if (err) {
    return false;
  } else {
    return true;
  }
};

const fileDuplicateCheck = () => {
  for (var info of manualInfo) {
    if (
      info.fileName == fileName.value &&
      fileName.value != oldFileName.value
    ) {
      return true;
    }
  }
  return false;
};

const clearMsg = () => {
  errManualName.value = "";
  errDescription.value = "";
  errContent.value = "";
  errCategoryName.value = "";
};

onUpdated(function () {
  handleResize();
});

/** update manual */
const modalShow1 = (param) => {
  modalSubject.splice(0);
  manualModalBody.splice(0);
  modalSubject.push("Edit Manual");

  fileChange.value = "0";
  clearMsg();
  clearFile();

  oldManualId.value = param.id;
  manualName.value = param.name;
  oldManualName.value = param.name;
  description.value = param.description;
  fileName.value = param.fileName;
  oldFileName.value = param.fileName;
  categoryInfoName.value = param.category;
};

const clearFile = () => {
  uploadFile.splice(0);
  fileName.value = "";
  isLoading.value = false;
};

const selectFileButton = () => {
  document.getElementById("inputFile").click();
};

/** add manual */
const modalShow2 = () => {
  modalSubject.splice(0);
  manualModalBody.splice(0);
  modalSubject.push("Add New Manual");

  manualName.value = "";
  description.value = "";
  fileName.value = "";
  categoryInfoName.value = "";

  clearMsg();
};

/** add category */
const addCategory = () => {
  store.dispatch("setShowPage", "CategoryEdit");
};

/** カテゴリーのマニュアル表示順変更(Up/Down) */
const manualMoveUpDown = (index, direction) => {
  var paramValue = {
    "manualMoveDirection": direction,
    "manualId1": manualInfo[0][index].id,
    "manualOrder1": manualInfo[0][index].manualOrder,
    "manualId2": direction == "Up" ? manualInfo[0][index - 1].id : manualInfo[0][index + 1].id,
    "manualOrder2": direction == "Up" ? manualInfo[0][index - 1].manualOrder : manualInfo[0][index + 1].manualOrder
  }
  // update Manual Order Data
  ManualInfoDataService.updateManualInfo(paramValue)
    .then((_) => {
      if (direction == "Up") {
        manualInfo[0][index].manualOrder = paramValue.manualOrder2;
        let oriValue = manualInfo[0][index];
        manualInfo[0][index - 1].manualOrder = paramValue.manualOrder1;
        manualInfo[0].splice(index, 1, manualInfo[0][index - 1]);
        manualInfo[0].splice(index - 1, 1, oriValue);
      } else {
        manualInfo[0][index].manualOrder = paramValue.manualOrder2;
        let oriValue = manualInfo[0][index];
        manualInfo[0][index + 1].manualOrder = paramValue.manualOrder1;
        manualInfo[0].splice(index, 1, manualInfo[0][index + 1]);
        manualInfo[0].splice(index + 1, 1, oriValue);
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err035");
      alertState.value = "error";
      isLoading.value = false;
    });
}

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, modalSubject, manualModalBody, manualInfo, oldColoredCategory, categoryColor, getData, categoryInfo, manualName, description, oldManualId, fileName, oldFileName, categoryInfoName, uploadFile, fileChange, errDescription, errManualName, errContent, errCategoryName, oldManualName, handleResize, manualRowColoring, getManualList, getCategoryList, updateManualList, addManualList, selectFile, deleteManualList, inputCheck, fileDuplicateCheck, clearMsg, modalShow1, clearFile, selectFileButton, modalShow2, addCategory, manualMoveUpDown, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})